// extracted by mini-css-extract-plugin
export default {"legendItem":"+6Mdc","color":"lTnjt"};